import React from 'react';
import PropTypes from 'prop-types';
import SelectView from './SelectView.js';

export default class SelectViewContainer extends React.Component {
  constructor(props) {
    super(props);

    this.selectForEditing = this.selectForEditing.bind(this);

    this.state = {
      itemToEdit: null
    };
  }

  selectForEditing(key) {
    this.setState({
      itemToEdit: (this.state.itemToEdit === key) ? null : key
    });
  }

  render() {
    return (
      <SelectView
        selectForEditing={this.selectForEditing}
        itemKeyForEditing={this.state.itemToEdit}
        {...this.props}
      />
    );
  }
}

SelectViewContainer.propTypes = {
  handleSuccess: PropTypes.func,
  focusSearchInput: PropTypes.func,
};
SelectViewContainer.defaultProps = {
  handleSuccess: () => undefined,
  focusSearchInput: () => undefined,
};
